import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function CookiePolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1481">
      <section className="bg-teal-900 text-white py-16" data-id="element-1482">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1483">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1484">Cookie Policy</h1>
          <p className="text-teal-100" data-id="element-1485">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1486">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1487">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1488">
            <p className="lead" data-id="element-1489">
              This Cookie Policy explains how Dentico Dental Clinic Ltd uses
              cookies and similar technologies on denticoclinic.co.uk.
            </p>

            <h3 data-id="element-1490">We use:</h3>
            <ul className="space-y-2" data-id="element-1491">
              <li data-id="element-1492">
                <strong data-id="element-1493">Strictly necessary cookies</strong> — required for core
                site functionality.
              </li>
              <li data-id="element-1494">
                <strong data-id="element-1495">Analytics cookies</strong> — to understand website
                performance and improve user experience (used with consent where
                required).
              </li>
              <li data-id="element-1496">
                <strong data-id="element-1497">Functional cookies</strong> — to remember preferences
                such as language/settings.
              </li>
              <li data-id="element-1498">
                <strong data-id="element-1499">Marketing cookies</strong> (if enabled) — to measure
                campaign performance.
              </li>
            </ul>

            <h3 data-id="element-1500">Managing Cookies</h3>
            <p data-id="element-1501">
              You can manage cookie preferences in our cookie banner/settings
              and in your browser.
            </p>
            <p data-id="element-1502">
              Some third-party services (e.g. analytics/maps/booking tools) may
              set cookies under their own policies.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1503">
              <p data-id="element-1504">
                Contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-1505">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}